import styles from './Icon.module.css';
import { iconPaths } from './icons';

export interface IconProps {
  name: string;
  size?: 'sm' | 'md' | 'lg';
  /** R1 color token name (default: p500) */
  color?: string;
  /** Accessible label */
  label?: string;
  className?: string;
}

export function Icon({
  name,
  size = 'md',
  color = 'p500',
  label,
  className,
}: IconProps) {
  const svg = iconPaths[name];

  if (!svg) {
    return null;
  }

  return (
    <span
      data-crd-id="r2.bq-icon"
      data-crd-layer="r2"
      className={`${styles.icon} ${styles[size]} ${className ?? ''}`}
      style={{ color: `rgba(var(--bq-${color}), 1)` }}
      role={label ? 'img' : 'presentation'}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      {svg}
    </span>
  );
}
